 <h1 mat-dialog-title class="header">
    View/Update Extended Account Info
    <button mat-icon-button class="close" (click)="closeDialog()">
          <mat-icon>close</mat-icon>
        </button>
  </h1> 
    <div *ngIf="spin" class="spinner-wrapper">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>
  <div  class="form-container">
     <div  class="form-grid">
   <ng-container *ngFor="let item of extendedaccountinfo.EXTENDEDACCOUNTINFO; let i =index">

 <div  class="form-item">
     <mat-checkbox style=" width:50% !important;" *ngIf="item.ATTRIBUTETYPE=='CHECKBOX'"
                  [disabled]="(item.ATTRIBUTEACCESS == 'EDITABLE'? false : true)"
                   [name]="item.ATTRIBUTENAME"
                  [checked]="item.ATTRIBUTEVALUE==='1'"
                  (change)="dataChanged($event.checked?'1':'0',i,item)"
                  >{{item.ATTRIBUTENAME}}
                </mat-checkbox>
 </div>

   </ng-container>
   </div>
   <div  class="actions">
    <button mat-raised-button color="primary" (click)="saveadditionalinfo()">
  Save
  
  </button>
   </div>
   </div>